import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "./LanguageContext";
import "./Breadcrumbs.css";

const categoryDetails = {
  Eventy: { label: "events", parentLabel: null, parentPath: null },
  Muzea: { label: "museums", parentLabel: "culture", parentPath: "/kultura" },
  Teatry: { label: "theatres", parentLabel: "culture", parentPath: "/kultura" },
  Kina: { label: "cinemas", parentLabel: "culture", parentPath: "/kultura" },
  Zabytki: { label: "monuments", parentLabel: "culture", parentPath: "/kultura" },
  KulturaInne: { label: "other", parentLabel: "culture", parentPath: "/kultura" },
  Restauracje: { label: "restaurants", parentLabel: "food", parentPath: "/gastronomia" },
  "Fast Foody": { label: "fastFood", parentLabel: "food", parentPath: "/gastronomia" },
  Kawiarnie: { label: "cafes", parentLabel: "food", parentPath: "/gastronomia" },
  Desery: { label: "desserts", parentLabel: "food", parentPath: "/gastronomia" },
  GastronomiaInne: { label: "other", parentLabel: "food", parentPath: "/gastronomia" },
  Biblioteki: { label: "libraries", parentLabel: "learning", parentPath: "/nauka" },
  Księgarnie: { label: "bookstores", parentLabel: "learning", parentPath: "/nauka" },
  Kursy: { label: "courses", parentLabel: "learning", parentPath: "/nauka" },
  "Targi i kiermasze": { label: "fairs", parentLabel: "learning", parentPath: "/nauka" },
  NaukaInne: { label: "other", parentLabel: "learning", parentPath: "/nauka" },
};

function Breadcrumbs({ category }) {
  const { t } = useLanguage();
  const details = categoryDetails[category];

  if (!details) {
    return null;
  }

  return (
    <div className="category-breadcrumbs breadcrumbs" role="navigation" aria-label={t("breadcrumbLabel")}>
      <Link to="/">{t("home")}</Link>
      <span aria-hidden="true">/</span>
      {details.parentLabel ? (
        <>
          <Link to={details.parentPath}>{t(details.parentLabel)}</Link>
          <span aria-hidden="true">/</span>
        </>
      ) : null}
      <span aria-current="page">{t(details.label)}</span>
    </div>
  );
}

export default Breadcrumbs;